module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('page-title', [_vm._v("Add Track")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "dismissible": ""
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n            Before you proceed, please make sure that track was not added already\n        ")]), _vm._v(" "), _c('form', [_c('v-subheader', {
    staticClass: "grey--text"
  }, [_c('strong', [_vm._v("Primary Info")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('input-track-source', {
    on: {
      "linked": _vm.autoFill
    },
    model: {
      value: (_vm.form.previewSource),
      callback: function($$v) {
        _vm.$set(_vm.form, "previewSource", $$v)
      },
      expression: "form.previewSource"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "disabled": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('span', [_vm._v("YouTube URL "), _c('br'), _vm._v(" where we can listen to the track")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('p', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Provider Title:")]), _vm._v(" "), _c('u', {
    staticClass: " "
  }, [_vm._v(_vm._s(_vm.providerTitle || "-"))])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('input-track-artist', {
    model: {
      value: (_vm.form.artist),
      callback: function($$v) {
        _vm.$set(_vm.form, "artist", $$v)
      },
      expression: "form.artist"
    }
  }), _vm._v(" "), _c('input-track-title', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.swap
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("swap_vert")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('span', [_vm._v("Swap Artist and Title")])])], 1)], 1)], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "grey--text"
  }, [_c('strong', [_vm._v("Metadata (optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('input-audio-tags', {
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("Add Track")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4070d079","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/TracksCreate/PageTracksCreate.vue
// module id = 359
// module chunks = 0